<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ product: ProductDocument }>();
const { onAddToCart, isDisabled, icon } = useAddToCart();
</script>

<template>
  <button class="btn-outline-circle" :disabled="!product.in_stock || isDisabled" @click="onAddToCart({ product_id: product.product_id, quantity: 1 })">
    <span class="size-6" :class="icon" />
  </button>
</template>
